module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_22-707267de8f65631fd2acc159cad40e67.jpg";